import { render, staticRenderFns } from "./Machine2.view.vue?vue&type=template&id=d81f2e5e&"
import script from "./Machine2.view.vue?vue&type=script&lang=js&"
export * from "./Machine2.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports